import { render, staticRenderFns } from "./Summary.vue?vue&type=template&id=6fda0c7c&scoped=true&"
import script from "./Summary.vue?vue&type=script&lang=js&"
export * from "./Summary.vue?vue&type=script&lang=js&"
import style0 from "./Summary.vue?vue&type=style&index=0&id=6fda0c7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fda0c7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fda0c7c')) {
      api.createRecord('6fda0c7c', component.options)
    } else {
      api.reload('6fda0c7c', component.options)
    }
    module.hot.accept("./Summary.vue?vue&type=template&id=6fda0c7c&scoped=true&", function () {
      api.rerender('6fda0c7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/tenders/Summary.vue"
export default component.exports